 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		16: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		16: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"54ca0fb2b2416e3ae8ae349216903b763ff7d7fa","2":"e036212fccbab1174514729cc04cd23cdd92d71b","3":"eef70ec7ccdd9138444974fb462ab0e21dfaf6a2","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"19e4762e47efd6488d785ad0a991ffddc017861b","6":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","7":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","8":"0621d8b58401fbbb4648cde9e41b980a21cfd385","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"8063d4c1a6d76c686d54d57a6cacf99f3d403ae7","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-jsx","27":"component---src-pages-calculator-jsx","28":"component---src-pages-case-studies-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-create-workspace-jsx","31":"component---src-pages-css-3-d-transform-examples-index-jsx","32":"component---src-pages-css-specificity-calculator-jsx","33":"component---src-pages-dear-manager-jsx","34":"component---src-pages-disclaimer-jsx","35":"component---src-pages-docs-changelog-jsx","36":"component---src-pages-docs-faq-jsx","37":"component---src-pages-docs-index-jsx","38":"component---src-pages-docs-ui-overview-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-og-screenshot-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-responsive-design-glossary-jsx","61":"component---src-pages-responsive-website-test-jsx","62":"component---src-pages-screenshot-comparison-jsx","63":"component---src-pages-site-quality-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-pages-visualize-browser-sizes-jsx","72":"component---src-templates-blog-list-jsx","73":"component---src-templates-doc-jsx","74":"component---src-templates-post-jsx","75":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"ae379e001f0699e9cfbd","2":"3026a30782d896a41043","3":"01cf01c8bae070df8df2","4":"8a50615bc752d1273f48","5":"28d55d4abdeda5b65d3e","6":"3d3972828a9daacfebb8","7":"b3082e32b063ef523298","8":"2553e110bc55aabb2240","9":"ae0f1b8b7dc023d4685a","10":"fcc78712a2733817d295","11":"99ced224b35a92bf44dd","12":"7926e00e6ed7fa314542","13":"4d2271910e950a98f200","14":"2fa1069181af0cee496d","15":"17e8f6ce803cd747205a","17":"ffdb6f2c66f858d94e86","19":"b4eb345fa91d7a08a210","20":"4f130abc95859eb2ef85","21":"cb875b409f99cef5ce6b","22":"eef801f03774a19d4d8d","23":"01ec119ab4f2ed682c29","24":"ec15e7f86135dccae0bd","25":"9ef923d71fd2ec04d759","26":"e87d7b7c1868ecc6b355","27":"40da133f44290a254e7a","28":"dea628a9bd13983ec8bb","29":"fd992e33a66b96558a6e","30":"960d811088b2163054c8","31":"4b692bb57fbeee08982a","32":"8d8487d21df8517f3109","33":"6ace33fe75034930704a","34":"dac6c845d64a24b6b57c","35":"8872b8b5cf974cb2f3db","36":"a18c973602cd9c0b8528","37":"233991f41d92fe5c7499","38":"d94bb20d360f0cd7f5d4","39":"1c32b4e7dc223708b2ce","40":"41f7e7e741ab52fb93de","41":"323f535db2e1db6f5d44","42":"2bd01c499cf60bf4fbf6","43":"a4ae4b742c754e6a1dd9","44":"06779adf2f3fb7f74203","45":"1d946b9979b775cfdd58","46":"7589c2d5ad5f7670ae9a","47":"bdd0be66816f12189ba6","48":"ee7980e2e2600952b4c3","49":"fef090e7e8d40a259247","50":"e3723f022a4338aec453","51":"d378a0398ffc2eaaa72d","52":"2962ca1fcdef33953e91","53":"482f74c397bd152e2daf","54":"8e85b10ddde78654ffcc","55":"2584700ae2431bbfdcc6","56":"aa6f298a56b21e43d135","57":"f9f4714d98ac66743041","58":"5ba7f9c148dec62df7e6","59":"182eb728eef89e2e73cc","60":"28acec117d3a61043fbb","61":"0a47352886846acbe4ca","62":"2591b55d4f0583ebd9e9","63":"40f545d98003d25d2c50","64":"b18b72f24264bd3176d7","65":"48f5bdf393fae20ab3a3","66":"4726863255a7048274a3","67":"74d05e58c5fe1bc7de1d","68":"878fe94144b8f10028ef","69":"394accfdba6654325517","70":"d19eedcd7eafc25a7e56","71":"2a3c45a4a24a0d0fad5d","72":"c73d883d724cd305d893","73":"c598ddfda1c1945f171c","74":"25999014e54ea0298731","75":"634c4c6ec43ac6e401fe","77":"74b49508864cb6ee741f","78":"713c72510c202d5d5b90","79":"2f93fb32e39c25b49925","80":"518d410b1db5c686eead","81":"4a67e1771cc7f5e6dde4","82":"7e1c5cf6962f17a6a1df","83":"3efa175cf1e8622f2393","84":"4e5ad9d8cd589605abb5","85":"d739c050ffde958105d3","86":"ee33e1197ac48b0aad83"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"54ca0fb2b2416e3ae8ae349216903b763ff7d7fa","2":"e036212fccbab1174514729cc04cd23cdd92d71b","3":"eef70ec7ccdd9138444974fb462ab0e21dfaf6a2","4":"2c32dae14849a4f972874995451b6f57468ad597","5":"19e4762e47efd6488d785ad0a991ffddc017861b","6":"90f032246d4cdcf1d65eb1cf45f37ed8f593e782","7":"b840e4a0e0ec3abd82f448852459c0af2b1f0c75","8":"0621d8b58401fbbb4648cde9e41b980a21cfd385","9":"4a2c3bec25065dd2fdea912623f4dd70707c247a","10":"c6a2b77176a3bc3bec1b47526d84d42cd52f595b","11":"e9a0828a5d05114d8b38e47f15dd66585fc04534","12":"f54b42984bfe4d114461fcea2710af414ac1fe74","13":"framework","14":"7490bd49aa53622910970b252a264e0dd9ced745","15":"8063d4c1a6d76c686d54d57a6cacf99f3d403ae7","19":"component---src-pages-404-jsx","20":"component---src-pages-about-jsx","21":"component---src-pages-accessibility-index-jsx","22":"component---src-pages-accessibility-statement-jsx","23":"component---src-pages-accolades-jsx","24":"component---src-pages-alternative-index-jsx","25":"component---src-pages-black-friday-dear-manager-jsx","26":"component---src-pages-black-friday-index-jsx","27":"component---src-pages-calculator-jsx","28":"component---src-pages-case-studies-jsx","29":"component---src-pages-color-contrast-jsx","30":"component---src-pages-create-workspace-jsx","31":"component---src-pages-css-3-d-transform-examples-index-jsx","32":"component---src-pages-css-specificity-calculator-jsx","33":"component---src-pages-dear-manager-jsx","34":"component---src-pages-disclaimer-jsx","35":"component---src-pages-docs-changelog-jsx","36":"component---src-pages-docs-faq-jsx","37":"component---src-pages-docs-index-jsx","38":"component---src-pages-docs-ui-overview-jsx","39":"component---src-pages-download-jsx","40":"component---src-pages-experimental-web-platform-features-jsx","41":"component---src-pages-exported-panes-jsx","42":"component---src-pages-github-students-jsx","43":"component---src-pages-index-jsx","44":"component---src-pages-integrations-index-jsx","45":"component---src-pages-integrations-jetbrains-webstorm-jsx","46":"component---src-pages-integrations-markerio-jsx","47":"component---src-pages-integrations-toybox-systems-jsx","48":"component---src-pages-integrations-tumult-hype-jsx","49":"component---src-pages-integrations-tumult-whisk-jsx","50":"component---src-pages-legal-jsx","51":"component---src-pages-newsletter-jsx","52":"component---src-pages-og-screenshot-jsx","53":"component---src-pages-opener-jsx","54":"component---src-pages-portal-index-jsx","55":"component---src-pages-pricing-jsx","56":"component---src-pages-privacy-jsx","57":"component---src-pages-product-tour-jsx","58":"component---src-pages-quality-assurance-index-jsx","59":"component---src-pages-resources-jsx","60":"component---src-pages-responsive-design-glossary-jsx","61":"component---src-pages-responsive-website-test-jsx","62":"component---src-pages-screenshot-comparison-jsx","63":"component---src-pages-site-quality-index-jsx","64":"component---src-pages-social-media-previews-index-jsx","65":"component---src-pages-special-offers-jsx","66":"component---src-pages-support-index-jsx","67":"component---src-pages-syntax-jsx","68":"component---src-pages-tailwindcss-jsx","69":"component---src-pages-testimonials-jsx","70":"component---src-pages-thanks-jsx","71":"component---src-pages-visualize-browser-sizes-jsx","72":"component---src-templates-blog-list-jsx","73":"component---src-templates-doc-jsx","74":"component---src-templates-post-jsx","75":"component---src-templates-term-jsx"}[chunkId]||chunkId) + "." + {"0":"ea780661633766e145ab","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
